import api from "api/flexapi";
import { showToast } from "actions/toastActions";

export const BENEFITS_SURVEY_REQUEST = "BENEFITS_SURVEY_REQUEST";
export const BENEFITS_SURVEY_SUCCESS = "BENEFITS_SURVEY_SUCCESS";
export const BENEFITS_SURVEY_FAILURE = "BENEFITS_SURVEY_FAILURE";

export const SAVE_BENEFITS_SURVEY_REQUEST = "SAVE_BENEFITS_SURVEY_REQUEST";
export const SAVE_BENEFITS_SURVEY_SUCCESS = "SAVE_BENEFITS_SURVEY_SUCCESS";
export const SAVE_BENEFITS_SURVEY_FAILURE = "SAVE_BENEFITS_SURVEY_FAILURE";

export const DISABLE_SURVEY_REDIRECTION = "DISABLE_SURVEY_REDIRECTION";

export const loadBenefitsSurvey = () => dispatch => {
  dispatch({ type: BENEFITS_SURVEY_REQUEST, payload: null });

  api
    .getBenefitsSurvey()
    .then(response =>
      dispatch({
        type: BENEFITS_SURVEY_SUCCESS,
        payload: response.body,
      })
    )
    .catch(err =>
      dispatch({
        type: BENEFITS_SURVEY_FAILURE,
        payload: err.response ? err.response.body : err,
      })
    );
};

export const saveBenefitsSurvey = (surveyId, data, redirectAfterSubmit) => dispatch => {
  let surveyDocuments = [];
  let formData = Object.assign({}, data);
  const savingSuccessText = "Your response was submitted successfully.";

  for (const questionId in formData) {
    if (Array.isArray(formData[questionId])) {
      if (formData[questionId].length === 0) {
        formData[questionId] = 0;
      } else {
        const { [questionId]: files, ...rest } = formData;

        surveyDocuments = surveyDocuments.concat({
          questionId: questionId,
          file: files[0],
        });

        formData = Object.assign({}, rest);
      }
    }

    if (typeof formData[questionId] === "object" && !Array.isArray(formData[questionId])) {
      formData[questionId] = formData[questionId].pkDigitalContent;
    }
  }

  const surveyDocumentsPromises = Promise.all(
    surveyDocuments.map(({ questionId, file }) =>
      api.postSurveyDocument(file).then(response => {
        return { [questionId]: response.body.pkDigitalContent };
      })
    )
  );

  surveyDocumentsPromises
    .then(responses => {
      const combinedFilesObj = responses.map(res => res).reduce((prev, curr) => {
        return { ...prev, ...curr };
      }, {});

      const surveyData = { ...combinedFilesObj, ...formData };

      dispatch({ type: SAVE_BENEFITS_SURVEY_REQUEST, payload: null });
      api
        .saveBenefitsSurvey(surveyId, surveyData)
        .then(response => {
          dispatch({
            type: SAVE_BENEFITS_SURVEY_SUCCESS,
            payload: {
              saveResponse: response.body,
              redirectAfterSubmit,
            },
          });

          if (response.body) {
            dispatch(showToast({ message: savingSuccessText })); // this is being localised in Toast component
          }
        })
        .catch(err => {
          dispatch({ type: SAVE_BENEFITS_SURVEY_FAILURE, payload: err });
        });
    })
    .catch(err => {
      dispatch({ type: BENEFITS_SURVEY_FAILURE, payload: err });
    });
};

export const disableRedirection = () => dispatch =>
  dispatch({ type: DISABLE_SURVEY_REDIRECTION, payload: null });



// WEBPACK FOOTER //
// ./actions/benefitsSurveyActions.js